export default "__VITE_ASSET__DgCIzkUo__"